import { GroupOrderEndedScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <GroupOrderEndedScreen />;
}
